import { render, staticRenderFns } from "./HotProduct.vue?vue&type=template&id=1f81a6fa&scoped=true"
import script from "./HotProduct.vue?vue&type=script&lang=js"
export * from "./HotProduct.vue?vue&type=script&lang=js"
import style0 from "./HotProduct.vue?vue&type=style&index=0&id=1f81a6fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81a6fa",
  null
  
)

export default component.exports